// extracted by mini-css-extract-plugin
export var divider = "_1v-0";
export var dividerText = "_1v-2";
export var dividerVertical = "_1v-1";